import SettingsTypes from './settings.types';
import { handleInputChange } from './settings.utils';

const initialSetting = {
	IsLogin: true, //to verify user logged in or not
	ErrorMsg: '', // to show the error message popup
	organisationID: 0,
	organisationName: '',
	licenseKey: '',
	speechIsOn: false,
	Msg: '',
	isNotify: {},
	speechOn: { disabled: 'disabled' },
	notifyClick: {},
	notificationText: '',
	certificates: {},
	speechModal: {},
	notificationIsOn: 0,
};

export const settingsDetails = (state = initialSetting, action = {}) => {
	switch (action.type) {
		case SettingsTypes.UPDATE_SETTINGS:
		case SettingsTypes.FETCH_LICENSE.SUCCESS:
		case SettingsTypes.FETCH_CHECK_SPEECH.SUCCESS:
		case SettingsTypes.FETCH_ORDERS.SUCCESS:
		case SettingsTypes.CHECK_NOTIFICATION.SUCCESS:
			return Object.assign({}, state, { ...action.payload });
		case SettingsTypes.FETCH_CERTIFICATES.SUCCESS:
			return Object.assign({}, state, { certificates: action.payload });
		case SettingsTypes.UPDATE_NOTIFICATION_STATUS:
			return Object.assign({}, state, { notificationIsOn: action.payload });
		case SettingsTypes.DISABLE_MIC.SUCCESS:
			return Object.assign({}, state, { speechIsOn: action.payload });
		case SettingsTypes.HANDLE_INPUT_CHANGE:
			return Object.assign({}, state, { ...handleInputChange(action.payload) });
		default:
			return state;
	}
};
